export default "__VITE_PUBLIC_ASSET__06968b80__"